import TradeInterface from "./TradeInterface";

export default TradeInterface;
